module.exports = __webpack_public_path__ + "img/20220822143519611961.1281addf.jpg";